import { api } from '@/lib/api';
import type { SourceCoverage } from '@waypoint/shared';

export interface RenewalItem {
  id: string;
  source: 'hubspot' | 'close' | 'qbo-recurring';
  customerName: string;
  customerExternalId: string | null;
  amountCents: number;
  lifetimeRevenueCents: number;
  daysUntilRenewal: number | null;
  cadence: 'monthly' | 'quarterly' | 'annual' | 'one-time' | null;
  bucket: '0-30' | '31-60' | '61-90' | '91-180' | 'overdue';
  riskScore: number;
  reason: string;
}

export interface RenewalCliffResult {
  /** null (with summary) when no CRM is connected and synced: "no renewals at risk" is not claimable. */
  items: RenewalItem[] | null;
  summary: {
    total: number;
    overdue: number;
    next30Days: number;
    next90Days: number;
    totalValueAtRiskCents: number;
  } | null;
  coverage?: SourceCoverage;
}

// A failed read claims nothing: no summary, no coverage.
const MOCK: RenewalCliffResult = { items: null, summary: null };

export async function getRenewalCliff(): Promise<RenewalCliffResult> {
  try {
    return await api('/v1/renewal-cliff');
  } catch {
    return MOCK;
  }
}
